import type { NDateLocale } from './enUS'
import { el } from 'date-fns/locale'

const dateElGR: NDateLocale = {
  name: 'el-GR',
  locale: el
}

export default dateElGR
